import { Flex as ChakraFlex, type FlexProps as ChakraFlexProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ChakraFlexProps {}

export default forwardRef<HTMLDivElement, Props>((props, ref) => {
  return <ChakraFlex ref={ref} {...props} />
})